import { render, staticRenderFns } from "./MatchdaySlider.vue?vue&type=template&id=75f5ba60"
import script from "./MatchdaySlider.vue?vue&type=script&lang=js"
export * from "./MatchdaySlider.vue?vue&type=script&lang=js"
import style0 from "./MatchdaySlider.vue?vue&type=style&index=0&id=75f5ba60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports